import {useTranslation} from "react-i18next";
import {useCallback, useState} from "react";
import {dateToMoscowTimestamp, getCurrentMoscowTime} from "../../../time";
import WithTooltip from "../../../ui/tooltip";
import {HelpCircleIcon} from "../../../ui/icons";
import DatePicker from "../../../ui/datepicker";
import Button from "../../../ui/button";

import classes from "./ActivateParticipationModal.module.css";

type props = {
  userId: string;
  challengeId: string;
  onSetStatus?: (
    userId: string,
    status: boolean,
    challengeId?: string,
    projectId?: string,
    deactivateAt?: number,
    emails?: string[],
  ) => void;
  remove?: () => void;
};

function Header() {
  const {t} = useTranslation();

  return (
    <>
      <span>{t("components.ActivateParticipationModal.title")}</span>
    </>
  );
}

function Content({userId, challengeId, onSetStatus, remove}: props) {
  const {t} = useTranslation();

  const nowDate = new Date();
  const [deactivateAt, setDeactivateAt] = useState<Date | undefined>(undefined);

  const filterPassedTime = (time: Date) => {
    const moscowTime = getCurrentMoscowTime();
    if (time && moscowTime) {
      return time.getTime() > moscowTime;
    }
    return true;
  };

  const onSubmitClick = useCallback(() => {
    onSetStatus &&
      onSetStatus(userId, true, challengeId, undefined, deactivateAt && dateToMoscowTimestamp(deactivateAt));
    remove && remove();
  }, [deactivateAt, challengeId, userId, onSetStatus, remove]);

  return (
    <>
      <div className={classes.helpItem}>
        <p className={classes.helpText}>{t("components.ActivateParticipationModal.helpText.active")}</p>
        <WithTooltip
          className={classes.helpCircleIcon}
          as="span"
          helpText={t("components.ActivateParticipationModal.helpText.timeMsk")}
        >
          <HelpCircleIcon />
        </WithTooltip>
      </div>

      <div className="flex items-center gap-4">
        <DatePicker
          className={classes.customDatePicker}
          onChange={(value: Date) => setDeactivateAt(value ?? undefined)}
          selected={deactivateAt}
          minDate={nowDate}
          filterTime={(time) => filterPassedTime(time)}
          placeholderText={t("components.ActivateParticipationModal.datePicker.activeTo")}
          timeCaption={t("components.ActivateParticipationModal.datePicker.time")}
          showTimeSelect
          dateFormat="Pp"
          timeIntervals={15}
          shouldCloseOnSelect={true}
        />
      </div>

      <div className={classes.bottom}>
        <Button type="submit" color="success" className={classes.button} onClick={onSubmitClick}>
          {t("components.ActivateParticipationModal.submit")}
        </Button>
      </div>
    </>
  );
}

const ActivateParticipationModal = {
  Header: Header,
  Content: Content,
};

export default ActivateParticipationModal;
